<template>
    <tr>
        <td colspan="3" class="p-day-one__own-head-of-loss--no-padding p-day-one__own-head-of-loss--no-top-border">
        <table class="u-full-width">
            <tr>
                <td width="40%" class="p-day-one__own-head-of-loss--no-border">
                    <input type="text" v-model="name"/>
                </td>
                <td width="40%" class="p-day-one__own-head-of-loss--no-top-bottom-border">
                    <div class="a-form-inputs--pound">
                        <input type="number" v-model.number="amount"/>
                    </div>
                </td>
                <td width="20%" class="p-day-one__own-head-of-loss--no-border">
                    <button class="a-button" @click="remove">Remove</button>
                </td>
            </tr>
        </table>
        </td>
    </tr>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: 'own-head-of-loss',
        props: {
            headOfLoss: {
                type: Object,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            type: {
                type: String,
                default: 'fatal'
            }
        },
        computed: {
            name: {
                get() {
                    return this.headOfLoss.name;
                },
                set(value) {
                    if (this.type === 'fatal') {
                        return this.updateFatalHeadOfLoss({
                            key: 'name',
                            index: this.index,
                            value
                        })
                    }
                    return this.updateLostHeadOfLoss({
                        key: 'name',
                        index: this.index,
                        value
                    })

                }
            },
            amount: {
                get() {
                    return this.headOfLoss.value;
                },
                set(value) {
                    if (this.type === 'fatal') {
                        return this.updateFatalHeadOfLoss({
                            key: 'value',
                            index: this.index,
                            value
                        })
                    }
                    return this.updateLostHeadOfLoss({
                        key: 'value',
                        index: this.index,
                        value
                    })
                }
            }
        },
        methods: {
            ...mapActions('reserves/dayOneFatal', {
                updateFatalHeadOfLoss: 'updateHeadOfLoss',
                deleteFatalHeadOfLoss: 'deleteHeadOfLoss'
            }),
            ...mapActions('reserves/dayOneLost', {
                updateLostHeadOfLoss:'updateHeadOfLoss',
                deleteLostHeadOfLoss: 'deleteHeadOfLoss'
            }),
            remove() {
                if (this.type === 'fatal') {
                    return this.deleteFatalHeadOfLoss(this.index);
                }
                return this.deleteLostHeadOfLoss(this.index);
            }
        }

    }
</script>


// WEBPACK FOOTER //
// OwnHeadOfLoss.vue?216346f6